// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellFilledSvg from "@fishx/icons-svg/es/asn/BellFilled";
import FishxIcon from '../components/FishxIcon';

var BellFilled = function BellFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellFilledSvg
  }));
};

BellFilled.displayName = 'BellFilled';
export default React.forwardRef(BellFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BellFilled.js
// module id = 2067
// module chunks = 0